import { getSavedTheme } from "./theme"
import { serverZenLandscape, serverZenScenery } from "./appearance_prefs"

export const MANUAL_KEY = "zen-scenery-manual"
export const LANDSCAPE_KEY = "zen-landscape-id"
export const STORAGE_KEY = "zen-scenery-id"
const LANDSCAPES = ["mountain", "future", "koi"]

// The four scenes that track time of day, and so track the light/dark theme.
// Everything else in a landscape is a MOOD (ocean, lavender, forest, coast,
// garden city, orbital, blossom, autumn, moss) and is a deliberate look that a
// theme toggle has no business overwriting. Exported so zen_scenery_controller
// reads the same list rather than keeping a second copy of it.
export const TIME_SCENES = ["dawn", "day", "dusk", "night"]

export const sceneryForTheme = (theme) => (theme === "dark" ? "night" : "day")

export const sceneryStorageKey = (landscape) => (
    landscape === "mountain" ? STORAGE_KEY : `${STORAGE_KEY}-${landscape}`
)

export const getSavedLandscape = () => {
    const saved = localStorage.getItem(LANDSCAPE_KEY)
    if (LANDSCAPES.includes(saved)) return saved

    const stored = serverZenLandscape()
    return LANDSCAPES.includes(stored) ? stored : "mountain"
}

export const markSceneryManual = () => localStorage.setItem(MANUAL_KEY, "1")

export const clearSceneryManual = () => localStorage.removeItem(MANUAL_KEY)

export const isSceneryManual = () => localStorage.getItem(MANUAL_KEY) === "1"

// Seed this device from the member's stored preference when localStorage has
// nothing of its own. The scene still determines whether theme changes may
// re-tint it: time-of-day scenes track the theme, custom moods retain their look.
export const seedSceneryFromServer = () => {
    const landscape = getSavedLandscape()
    if (localStorage.getItem(sceneryStorageKey(landscape))) return

    const scenery = serverZenScenery()
    if (!scenery) return

    if (!localStorage.getItem(LANDSCAPE_KEY) && serverZenLandscape()) {
        localStorage.setItem(LANDSCAPE_KEY, landscape)
    }
    localStorage.setItem(sceneryStorageKey(landscape), scenery)
    markSceneryManual()
}

// Time-of-day scenes follow the theme even after a menu pick or a server
// restore marked them manual. Otherwise choosing Day once pins a bright sky
// through every later dark-mode toggle. Custom moods (Ocean, Forest, etc.)
// retain their look regardless of the legacy manual flag.
const sceneryTracksTheme = (landscape) => {
    const saved = localStorage.getItem(sceneryStorageKey(landscape))
    if (!saved) return true
    return TIME_SCENES.includes(saved)
}

export const needsThemeScenerySync = (theme) => {
    const landscape = getSavedLandscape()
    if (!sceneryTracksTheme(landscape)) return false

    const saved = localStorage.getItem(sceneryStorageKey(landscape))
    if (!saved) return false
    return saved !== sceneryForTheme(theme)
}

export const syncSceneryToTheme = (theme, { animate = true } = {}) => {
    const landscape = getSavedLandscape()
    if (!sceneryTracksTheme(landscape)) return

    const sceneryId = sceneryForTheme(theme)
    localStorage.setItem(sceneryStorageKey(landscape), sceneryId)
    document.dispatchEvent(new CustomEvent("emailpa:scenerysync", {
        detail: { theme, sceneryId, landscape, animate }
    }))
}

export const syncSceneryToSavedTheme = (options = {}) => {
    syncSceneryToTheme(getSavedTheme(), options)
}
